import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { AlarmSosDialogListener } from './alarm-sos-dialog.listener';

export function provideAlarmSosDialog(): EnvironmentProviders {
  return provideAppInitializer(() => {
    inject(AlarmSosDialogListener).init();
  });
}
